import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'h3-navbar-project-status-indicator',
  templateUrl: './navbar-project-status-indicator.svg',
  styleUrls: ['./navbar-project-status-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarProjectStatusIndicatorComponent implements OnChanges {
  @Input() projectType?: string;
  @Input() @HostBinding('class.paused') isProjectPaused = false;
  @HostBinding('class.delivery') isDelivery = false;
  @HostBinding('class.training') isTraining = false;
  @HostBinding('class.certification') isCertification = false;

  ngOnChanges() {
    const projectType = this.projectType?.toLowerCase();
    this.isDelivery = projectType === 'delivery';
    this.isTraining = projectType === 'training';
    this.isCertification = projectType === 'certification';
  }
}
